/* eslint-disable @typescript-eslint/no-explicit-any */
import QuoteBlade from './QuoteBlade';
import ClaimBlade from './ClaimBlade';
import MainMenuBlade from './MainMenuBlade';

interface BladeControllerProps {
  className?: string;
  data: {
    id: string;
    bladeType: string;
    title: string;
    closeLabel: string;
    button: any;
    menuOpenLabel: string;
    menuCloseLabel: string;
    introParagraph: string;
    menu: any;
    hamburgerMenuBlade: {
      id: string;
      title: string;
      items: {
        id: string;
        title: string;
        url: string;
      }[];
    };
  };
  onKeyDown?: any;
}
const BladeController = ({ className = '', data, onKeyDown }: BladeControllerProps) => {
  switch (data?.bladeType) {
    case 'get-a-quote':
      return (
        data.menu && (
          <QuoteBlade
            key={data.id}
            title={data.title}
            className={className}
            closeMsg={data.closeLabel}
            cta={data.button}
            menu={data.menu}
            onKeyDown={onKeyDown}
          />
        )
      );
    case 'make-a-claim':
      return (
        data.menu && (
          <ClaimBlade
            key={data.id}
            title={data.title}
            className={className}
            closeMsg={data.closeLabel}
            cta={data.button}
            intro={data.introParagraph}
            menu={data.menu}
            onKeyDown={onKeyDown}
          />
        )
      );
    case 'main-menu':
      return (
        <MainMenuBlade
          className={className}
          title={data.menuOpenLabel}
          closeMsg={data.menuCloseLabel}
          menu={data.hamburgerMenuBlade}
        />
      );
    default:
      return null;
  }
};

export default BladeController;
